const gqlCampaign = `query ($campaignId:ID!) {
    campaign(id:$campaignId){
      id
      name
      pitchUrl
      type
      bonusLimit
      country{
        currencySign
        code
      }
      metrics {
        nodes {
          id
          name
          targetConversionRate
          targetCostPerMetric
          isPrimary
        }
      }
      client {
        id
        logo
      }
      clientReferralProgram{
       npsEmailDate
       referralEmailDate
       score
      }
      status
      deliverabilityReport{
       id
      }
      cityPlans{
        nodes {
           id
        }
      }
    }
  }`

const gqlCityPlans = `
  query ($cityPlanId:ID!) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
          id
          payout
          distributionCost: distributionCostV2
          teamLeaderPayAdjustment
          city {
            id
            name
            lunchCheckInTime
            afternoonCheckInTime
            teamLeaderEnabled
            latitude
            longitude
            country {
              id
              name
              code
            }
            locations{
              edges {
                node {
                  id
                  name
                  hasPermit
                  rank
                  detailedRank
                  type {
                    name
                  }
                }
              }
            }
          }
          permitCosts {
            nodes {
              id
              cost
              startDate
            }
          }
        }
      }
    }
  }
  `

const gqlMissions = `
   query ($cityPlanId:ID!, $missionStatuses: [MissionStatusEnum], $first: Int, $skip: Int) {
    cityPlans(cityPlanId: $cityPlanId) {
      edges {
        node {
           id
          missions(statuses: $missionStatuses, first: $first, skip: $skip) {
            pageInfo {
              hasNextPage
            }
            edges {
              node {
                id
                flyerCode
                flyerCodeV2 {
                  id
                  code
                  tag
                }
                status
                totalFlyersDistributed
                dateTime
                distributionCost: distributionCostV2
                draftPayAdjustment
                printingCostPerFlyer: printingCostPerFlyerV2
                packSize
                bonusPerConversion
                bonusRedemptionPeriod
                cancelled
                automatic
                type
                user {
                  id
                  firstName
                  lastName
                }
                location {
                  id
                  name
                  hasPermit
                  rank
                  detailedRank
                  type {
                    name
                  }
                }
                metricResults {
                  nodes {
                    id
                    value
                    metric {
                      id
                      name
                    }
                  }
                }
                conversions {
                  nodes {
                    id
                    timestamp
                    metric {
                      id
                      isPrimary
                    }
                  }
                }
                boundary {
                  latitude
                  longitude
                }
                boundaryColour
                costPerFlyer
                amountScans
              }
            }
          }
        }
      }
    }
  }
  `

export { gqlCampaign, gqlCityPlans, gqlMissions }



// WEBPACK FOOTER //
// ./src/Containers/StatsDashboard/gql.js